const MAGIC_SCHOOLS = {
  simple: [
    { id: "fire", name: "Fire Magic", tier: "Simple", statMin: 5, useCost: 1, powerDice: "D4" },
    { id: "water", name: "Water Magic", tier: "Simple", statMin: 5, useCost: 1, powerDice: "D4" },
    { id: "earth", name: "Earth Magic", tier: "Simple", statMin: 5, useCost: 1, powerDice: "D4" },
    { id: "air", name: "Air Magic", tier: "Simple", statMin: 5, useCost: 1, powerDice: "D4" },
    { id: "healing", name: "Healing Magic", tier: "Simple", statMin: 5, useCost: 1, powerDice: "D4" },
  ],
  standard: [
    { id: "illusion", name: "Illusion Magic", tier: "Standard", statMin: 15, useCost: 2, powerDice: "D4" },
    { id: "animal", name: "Animal Magic", tier: "Standard", statMin: 15, useCost: 2, powerDice: "D4" },
    { id: "plant", name: "Plant Magic", tier: "Standard", statMin: 15, useCost: 2, powerDice: "D4" },
    { id: "lightning", name: "Lightning Magic", tier: "Standard", statMin: 15, useCost: 2, powerDice: "D4" },
  ],
  great: [
    { id: "shadow", name: "Shadow Magic", tier: "Great", statMin: 30, useCost: 3, powerDice: "D6" },
    { id: "light", name: "Light Magic", tier: "Great", statMin: 30, useCost: 3, powerDice: "D6" },
    { id: "telekinesis", name: "Telekinesis", tier: "Great", statMin: 30, useCost: 3, powerDice: "D6" },
  ],
  master: [
    { id: "time", name: "Time Magic", tier: "Master", statMin: 50, useCost: 5, powerDice: "D6" },
    { id: "space", name: "Space Magic", tier: "Master", statMin: 50, useCost: 5, powerDice: "D6" },
    { id: "necromancy", name: "Necromancy", tier: "Master", statMin: 50, useCost: 5, powerDice: "D6" },
  ],
};

export default MAGIC_SCHOOLS
